import React from 'react';
import { HeartHandshake, Smile, UsersRound } from 'lucide-react';
import { missionPoints } from '../mock';
import { Card, CardContent } from './ui/card';

const iconMap = {
  'heart-handshake': HeartHandshake,
  'smile': Smile,
  'users-round': UsersRound
};

const Mission = () => {
  return (
    <section id="mission" className="py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our Mission
          </h2>
          <div className="w-24 h-1 bg-teal-600 mx-auto mb-6"></div>
          <p className="text-lg text-gray-600 leading-relaxed">
            At Siyarasoi Foundation, we believe that access to nutritious food is a fundamental right. 
            Our mission is rooted in compassion, community, and the unwavering commitment to serve those in need.
          </p>
        </div>

        {/* Mission Points Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {missionPoints.map((point) => {
            const IconComponent = iconMap[point.icon];
            return (
              <Card key={point.id} className="border-2 border-gray-100 hover:border-teal-300 hover:shadow-lg transition-all duration-300 group">
                <CardContent className="p-8">
                  <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mb-6 group-hover:bg-teal-600 group-hover:scale-110 transition-all duration-300">
                    <IconComponent className="text-teal-600 group-hover:text-white transition-colors" size={32} />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">
                    {point.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {point.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Mission Image Section */}
        <div className="relative rounded-2xl overflow-hidden shadow-xl">
          <img
            src="/volunteer-serving.png"
            alt="Volunteers serving meals with Ayodhya temple in background"
            className="w-full h-96 object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-teal-900/80 via-teal-900/40 to-transparent flex items-end">
            <div className="p-8 sm:p-12">
              <h3 className="text-2xl sm:text-3xl font-bold text-white mb-3">
                Serving with Love & Compassion
              </h3>
              <p className="text-gray-100 text-lg max-w-2xl">
                Every meal we serve is prepared with care and delivered with respect, 
                ensuring that everyone in our community feels valued and supported.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Mission;
